import { Eye, Pencil, Trash2 } from "lucide-react";

export default function ActionMenu({
  onView,
  onEdit,
  onDelete,
}) {

  return (
    <div className="flex justify-center gap-3">

      {/* 👇 Agar onView aayega, tabhi Eye button dikhega 👇 */}
      {onView && (
        <button onClick={onView} title="View">
          <Eye className="text-blue-500 hover:scale-110 transition" />
        </button>
      )}

      {/* 👇 Agar onEdit aayega, tabhi Pencil button dikhega 👇 */}
      {onEdit && (
        <button onClick={onEdit} title="Edit">
          <Pencil className="text-yellow-500 hover:scale-110 transition" />
        </button>
      )}

      {/* 👇 Agar onDelete aayega, tabhi Trash button dikhega 👇 */}
      {onDelete && (
        <button onClick={onDelete} title="Delete">
          <Trash2 className="text-red-500 hover:scale-110 transition" />
        </button>
      )}

    </div>
  );
}